import React, { useEffect, useRef, useState } from "react";
import LoadingSpinner from "../components/common/LoadingSpinner";
import { httpReauest } from "../utils/httpRequest";
import { Link, useNavigate } from "react-router-dom";
import {
  FaArrowLeft,
  FaShoppingCart,
  FaUtensils,
  FaHome,
  FaGamepad,
  FaUser,
  FaShoppingBag,
} from "react-icons/fa";
import { MdLocationOn } from "react-icons/md";
import Layout from "../components/layout";
import { BASE_URL, CDN_BASE_URL } from "../config";
import {
  FaAngleLeft,
  FaAngleRight,
  FaDoorOpen,
  FaUserGroup,
} from "react-icons/fa6";
import { IoIosLogOut } from "react-icons/io";
import { LuLogOut } from "react-icons/lu";
import {
  Add,
  ArrowLeft2,
  ArrowRight2,
  LanguageSquare,
  Location,
  Logout,
  ShoppingBag,
  Translate,
} from "iconsax-reactjs";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const Profile = () => {
  const [loading, setLoading] = useState(true);
  const [data, setdata] = useState();
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  const [showSaveBtn, setShowSaveBtn] = useState(false);
  const fileInputRef = useRef(null);
  const [invites, setInvites] = useState();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    fetchFriends(user._id, user.token);
  }, []);

  const fetchFriends = async (userId, token) => {
    try {
      const res2 = await httpReauest(
        "GET",
        `/user/friends/invite/${userId}`,
        {},
        { "x-access-token": token }
      );
      setInvites(res2.data.data || []);
    } catch (error) {
      console.error("Error fetching friends:", error);
    }
  };

  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) {
      navigate("/login");
    }
    await httpReauest(
      "GET",
      "/user/info/" + user?._id,
      {},
      { "x-access-token": user?.token }
    )
      .then((res) => setdata(res.data.data?.user))
      .catch(() => {
        localStorage.removeItem("user");
        navigate("/login");
      });
    setLoading(false);
  }

  async function handleImageUpload() {
    const user = JSON.parse(localStorage.getItem("user"));
    const formData = new FormData();
    formData.append("profileImg", selectedImage);

    try {
      const res = await fetch(BASE_URL + "/user/updateProfileImg/" + user._id, {
        method: "POST",
        headers: {
          "x-access-token": user.token,
        },
        body: formData,
      });

      const result = await res.json();
      if (res.ok) {
        toast.success(t("alert_image_saved_successfully"));
        setShowSaveBtn(false);
        getData(); // Refresh data
      } else {
        toast.error(t("alert_image_save_error"));
      }
    } catch (error) {
      console.error(error);
      alert(t("alert_server_error"));
    }
  }

  function handleLogout(e) {
    e.preventDefault();
    localStorage.removeItem("user");
    navigate("/login");
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="min-h-screen flex flex-col pb-[62px]">
      <Layout>
        <div className="relative h-36 bg-[var(--primary)]">
          <div className="w-32 h-32 rounded-full p-1 absolute bottom-2 bg-white shadow-lg translate-y-1/2 left-1/2 -translate-x-1/2">
            <img
              src={
                previewImage
                  ? previewImage
                  : data?.profileImg
                  ? CDN_BASE_URL + data?.profileImg
                  : "/user.png"
              }
              alt="User Profile"
              className="w-full rounded-full object-cover h-full"
            />
            <button
              className="bg-blue-500 rounded-full text-white p-1 absolute left-0 bottom-2"
              onClick={() => fileInputRef.current.click()}
            >
              <Add size={18} />
            </button>
            <input
              type="file"
              accept="image/*"
              className="hidden"
              ref={fileInputRef}
              onChange={(e) => {
                const file = e.target.files[0];
                if (file) {
                  if (file.size > 1024 * 1024) {
                    toast.error(t("toast_image_size_error"));
                    return;
                  }
                  setSelectedImage(file);
                  setPreviewImage(URL.createObjectURL(file));
                  setShowSaveBtn(true);
                }
              }}
            />
          </div>
        </div>
        <div className="mt-16 px-4 pb-3 border-b-2 border-gray-600">
          <h1 className="text-center text-[28px] font-bold">{data?.name}</h1>
          <div className="text-[#444] ">
            <div className="flex justify-between items-center py-2">
              <span>{t("label_phone")}</span>
              <span className="text-[#000]">
                {data?.phone ? data?.phone : "___"}
              </span>
            </div>
            <div className="flex justify-between items-center py-2">
              <span>{t("login_email_label")}</span>
              <span className="text-[#000]">
                {data?.email ? data?.email : "___"}
              </span>
            </div>
            <div className="flex justify-between items-center py-2">
              <span>{t("label_birthdate")}</span>
              <span className="text-[#000]">{data?.birthdate}</span>
            </div>
          </div>
          {showSaveBtn && (
            <div className="mt-4 px-4">
              <button
                className="w-full bg-green-600 text-white py-2 rounded-lg"
                onClick={handleImageUpload}
              >
                {t("button_save_image")}
              </button>
            </div>
          )}
        </div>
        <div className="px-4">
          <Link
            to={"/profile/orders"}
            className="flex justify-between items-center py-4 text-[#000] border-b border-gray-400 hover:bg-green-700/30 duration-200"
          >
            <span className="flex gap-2 items-center ">
              <ShoppingBag size={22} /> {t("nav_orders")}
            </span>
            <span>
              <ArrowLeft2 size={20} className="ltr:rotate-180" />
            </span>
          </Link>

          <Link
            to={"/profile/friends"}
            className="flex justify-between items-center py-4 text-[#000] border-b border-gray-400 hover:bg-green-700/30 duration-200"
          >
            <span className="flex gap-2 items-center ">
              <FaUserGroup size={22} /> {t("friends")}{" "}
            </span>
            <span>
              <ArrowLeft2 size={20} className="ltr:rotate-180" />
            </span>
          </Link>

          <Link
            to={"/profile/address"}
            className="flex justify-between items-center py-4 text-[#000] border-b border-gray-400 hover:bg-green-700/30 duration-200"
          >
            <span className="flex gap-2 items-center ">
              <Location size={22} /> {t("nav_addresses")}
            </span>
            <span>
              <ArrowLeft2 size={20} className="ltr:rotate-180" />
            </span>
          </Link>

          <button
            onClick={handleLogout}
            className="flex justify-between w-full items-center py-4 text-[#000] border-b border-gray-400 hover:bg-green-700/30 duration-200"
          >
            <span className="flex gap-2 items-center ">
              <Logout size={22} /> {t("nav_logout")}
            </span>
            <span>
              <ArrowLeft2 size={20} className="ltr:rotate-180" />
            </span>
          </button>
        </div>
      </Layout>
    </div>
  );
};

export default Profile;
